module.exports = __webpack_public_path__ + "files/79f6b7a43be2ec8f8fa11383221f1063.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-italic-webfont.eot
// module id = 388
// module chunks = 60